export function tarefaTemResponsavel(tarefa) {
  const id = tarefa?.responsavel_id
  return id != null && id !== '' && Number(id) > 0
}

export function tarefaEstaFinalizada(status) {
  const s = (status || '').trim()
  return s === 'Concluído' || s === 'Cancelada'
}

/** Status real da entrega (somente exibição em cards/chips). */
export function entregaStatusEhConcluido(entrega) {
  return (entrega?.status || '').trim() === 'Concluído'
}

export function entregaStatusEhCancelado(entrega) {
  return (entrega?.status || '').trim() === 'Cancelada'
}

/** Entrega encerrada (concluída ou cancelada): não entra em cálculo de prazo/atraso. */
export function entregaEstaFinalizada(entrega) {
  return tarefaEstaFinalizada(entrega?.status)
}

/**
 * Bloqueio de edição por entrega concluída.
 * Temporariamente sempre false para permitir editar entregas e tarefas mesmo concluídas.
 */
export function entregaEstaConcluida(entrega) {
  entrega
  // return entregaStatusEhConcluido(entrega)
  return false
}

/** Tarefas da sprint Backlogs não entram na validação de conclusão da entrega. */
export function tarefaContaParaConclusaoEntrega(tarefa) {
  const sprintNome = (tarefa?.sprint_nome ?? '').trim()
  return sprintNome !== 'Backlogs'
}

export function extrairTarefasDeSprints(sprints) {
  const tarefas = []
  for (const sprint of sprints || []) {
    const sprintNome = (sprint?.nome ?? '').trim()
    for (const tarefa of sprint.backlogs || []) {
      tarefas.push({ ...tarefa, sprint_nome: sprintNome })
    }
  }
  return tarefas
}

export function tarefasImpedemConclusaoEntrega(tarefas) {
  return (tarefas || [])
    .filter((t) => tarefaContaParaConclusaoEntrega(t))
    .filter((t) => !tarefaEstaFinalizada(t?.status))
}

export function mensagemTarefasImpedemConclusaoEntrega(tarefasImpedem) {
  const lista = (tarefasImpedem || [])
    .map((t) => `• ${t.codigo ? `${t.codigo} — ` : ''}${t.descricao || 'Sem descrição'} (${t.status || 'Sem status'})`)
    .join('\n')
  return (
    'Não é possível concluir o pacote de trabalho enquanto houver tarefas não concluídas.\n\n'
    + `Tarefa(s) pendente(s):\n${lista}`
  )
}

export const MENSAGEM_TAREFA_SEM_RESPONSAVEL =
  'Não é possível alterar o status de uma tarefa sem responsável definido. Atribua um responsável antes de continuar.'
